import { render, staticRenderFns } from "./MobileCallme.vue?vue&type=template&id=52aae1ee&scoped=true"
import script from "./MobileCallme.vue?vue&type=script&lang=js"
export * from "./MobileCallme.vue?vue&type=script&lang=js"
import style0 from "./MobileCallme.vue?vue&type=style&index=0&id=52aae1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aae1ee",
  null
  
)

export default component.exports